function clearStateEventHandler(a) {
  delete a.sender.jsVars._reflowData, a.sender.jsVars._reflowData = {}, delete a.sender.jsVars._reflowClean;
}

export default {
  beforeInitialize: function beforeInitialize(a) {
    var b,
        c = a.sender,
        d = c.jsVars;
    d.fcObj = c, d.msgStore = d.msgStore || {
      LoadDataErrorText: 'Error in loading data.',
      XMLLoadingText: 'Retrieving data. Please wait',
      InvalidXMLText: 'Invalid data.',
      ChartNoDataText: 'No data to display.',
      ReadingDataText: 'Reading data. Please wait',
      ChartNotSupported: 'Chart type not supported.',
      PBarLoadingText: '',
      LoadingText: 'Loading chart. Please wait',
      RenderChartErrorText: 'Unable to render chart.'
    }, d.cfgStore = d.cfgStore || {}, d.previousDrawCount = -1, d.drawCount = 0, d._reflowData = {}, c.addEventListener('beforeRender', function (a) {
      return a.detachHandler();
    }), d.userModules instanceof Array || (b = d.userModules, d.userModules = [], 'string' == typeof b && (d.userModules = d.userModules.concat(b.split(','))));
  },
  beforeDataUpdate: clearStateEventHandler,
  beforeDispose: function beforeDispose(a) {
    var b = a.sender,
        c = b.jsVars;
    c.smartLabel && !c.smartLabel.disposed && c.smartLabel.dispose(), clearStateEventHandler.apply(void 0, arguments);
  },
  beforeRender: function beforeRender(a) {
    var b = a.sender,
        c = b.jsVars;
    delete c.drLoadAttempted, clearStateEventHandler.apply(void 0, arguments);
  },
  dataLoadRequested: function dataLoadRequested(a) {
    var b = a.sender,
        c = b.jsVars;
    delete c.loadError, b.ref && b.options.showDataLoadingMessage ? c.hcObj && !c.hasNativeMessage && c.hcObj.showLoading ? c.hcObj.showMessage(c.msgStore.XMLLoadingText) : b.ref.showChartMessage ? b.ref.showChartMessage('XMLLoadingText') : c.stallLoad = !0 : c.stallLoad = !0;
  },
  dataLoadRequestCompleted: function dataLoadRequestCompleted(a) {
    var b = a.sender,
        c = b.jsVars;
    delete c.stallLoad;
  }
};